// extracted by mini-css-extract-plugin
export var chevron = "ComponentCoverageList-module--chevron--1c6b7";
export var chevronWrapper = "ComponentCoverageList-module--chevronWrapper--d6ee7";
export var exclusions = "ComponentCoverageList-module--exclusions--90be0";
export var heading = "ComponentCoverageList-module--heading--e15e5";
export var inclusions = "ComponentCoverageList-module--inclusions--0a904";
export var list = "ComponentCoverageList-module--list--46818";
export var listItem = "ComponentCoverageList-module--listItem--18bfa";
export var modal = "ComponentCoverageList-module--modal--813af";
export var modalButton = "ComponentCoverageList-module--modalButton--92d2f";
export var modalButtonLabelDescription = "ComponentCoverageList-module--modalButtonLabelDescription--85223";
export var modalButtonLabelHeading = "ComponentCoverageList-module--modalButtonLabelHeading--46398";
export var modalRichTextHeading = "ComponentCoverageList-module--modalRichTextHeading--a34ce";
export var modalRichTextlist = "ComponentCoverageList-module--modalRichTextlist--23368";
export var modalRichTextlistItem = "ComponentCoverageList-module--modalRichTextlistItem--3425a";
export var reveal = "ComponentCoverageList-module--reveal--bebee";
export var section = "ComponentCoverageList-module--section--b9d1a";
export var subheading = "ComponentCoverageList-module--subheading--1fece";